// extracted by mini-css-extract-plugin
var _1 = "ntJkBbafwaaKR5rl0xQf";
var _2 = "tXQNmmFfLwGaXuq5Zi10";
var _3 = "RAqfE6XPH4tIkl7IjUCq";
var _4 = "L29hkh4uoSkhhTC73d0M";
var _5 = "b3B6HFQ8IscvCpxBiP_g";
var _6 = "LeLQic88GQ4JM57B1ylq";
var _7 = "D5HTNbd4fEBajq0uSFTp";
var _8 = "QsambHLS5K_hn3wOtxnu";
var _9 = "nHS4EVDbl5cGH_T0hIfA";
var _a = "RDqy42mLnPrsIlQ7WoWg";
var _b = "sITVGk0eh3KWNWUglMmV";
var _c = "YuU8iqsZ1m4y6DfvlHgH";
var _d = "A1RIpWNWmkxOT0kb2v2J";
var _e = "xSdjvwqZT98nHQx_7ncG";
var _f = "k78rlknIDpmjjtPWxKhU";
var _10 = "O9sC1c09PQtgoL5EUwxA";
var _11 = "i4TRtABbpXshPCBaA_U1";
var _12 = "qelY5ybW97rn7kii3A7o";
var _13 = "YfcszboeH8iFmDg6NFUw";
var _14 = "rnSjQMM3cb1DkycS138X";
export { _1 as "company-title", _2 as "container", _3 as "detail", _4 as "detail-link", _5 as "ext-icon", _6 as "font-roman", _7 as "margin-left-3-5-em", _8 as "marginTop", _9 as "need-more-link", _a as "need-more-mobile-link", _b as "paragraph", _c as "redesign-2021-heading-4", _d as "right-arrow", _e as "search-result-parent", _f as "suppressExtIcon", _10 as "title", _11 as "upik-search-result-card", _12 as "upik-search-result-container", _13 as "upik-search-result-item-card", _14 as "upik-search-result-paper" }
